import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAnalyticsResultMedia } from '@obvious.tech/constellation'

export const AnalyticsResultMedia = defineEntity('AnalyticsResultMedia', {
  endpoint: 'analytics/api/AnalyticsResultMedia',
  schema: SNoop<IAnalyticsResultMedia>(),
})
